<template>
  <v-form @submit.prevent="save" novalidate>
    <pr-box :title="titleBox">

      <div slot="buttons-header">
        <v-btn icon @click.native="goToList">
          <v-icon color="white">list</v-icon>
        </v-btn>
      </div>

      <v-text-field label="Nome" v-model="resource.name" :counter="100"
        :error-messages="validationErrors.name">
      </v-text-field>

      <v-text-field label="Email" v-model="resource.email" :counter="100"
        :error-messages="validationErrors.email">
      </v-text-field>

      <v-select
        :items="clients"
        item-text="name"
        item-value="id"
        hint="Vincular um cliente a este usuário (deixe em branco caso não queira vincular nenhum cliente)"
        v-model="client_id"
        persistent-hint
        clearable
        required
        :disabled="(disabledClient || clients.length === 0)"
        no-data-text="Nenhuma registro encontrado"
        placeholder="Selecione um cliente"
        :error-messages="validationErrors.client_id">
      </v-select>

      <v-radio-group v-model="roleId" required :error-messages="validationErrors['roles.id']">
        <div slot="label"><strong>Perfil de Usuário:</strong></div>
        <v-radio
          v-for="role in roles"
          :key="role.id"
          :label="role.title"
          :value="role.id"></v-radio>
      </v-radio-group>

      <v-radio-group v-model="api_user" row>
        <div slot="label"><strong>Usuário de API:</strong></div>
        <v-radio label="SIM" value="sim"></v-radio>
        <v-radio label="NÃO" value="nao"></v-radio>
      </v-radio-group>

      <v-alert
        :value="showAlert"
        type="error">
        Não existem clientes cadastrados no sistema.
      </v-alert>

      <div slot="buttons-footer">
        <v-btn flat type="submit" color="primary" :loading="saveLoading">Salvar</v-btn>
      </div>
    </pr-box>
  </v-form>
</template>

<script>
import CrudMixin from '@/components/mixins/CrudMixin';
import UserService from '@/features/user/UserService';
import RoleService from '@/features/role/RoleService';
import ClientService from '@/features/client/ClientService';

export default {
  name: 'user-form',
  mixins: [CrudMixin],
  data() {
    return {
      disabledClient: false,
      showAlert: false,
      roleId: null,
      roles: [],
      clients: [],
      client_id: null,
      selectedRoles: [],
      api_user: 'nao',
      roleService: new RoleService(),
      clientService: new ClientService(),
    };
  },
  created() {
    const user = this.$store.state.currentUser;
    if (!UserService.hasProfile(user, ['master', 'admin', 'analista'])) {
      this.client_id = user.client.id;
      this.disabledClient = true;
    }
    this.loadClient();
  },
  methods: {
    initCrud() {
      this.serviceType = UserService;
      this.routerName = 'user';
      this.componentType = 'FORM';

      this.roleService.query().then((data) => { this.roles = data; });
    },
    beforeSave() {
      this.resource.client_id = this.client_id ? this.client_id : null;
      this.resource.roles = [{ id: this.roleId }];
      this.resource.api_user = this.api_user;
    },
    afterLoadResource() {
      this.roleId = this.resource.roles.length > 0 ? this.resource.roles[0].id : null;
      this.client_id = this.resource.client_id;
      this.api_user = this.resource.api_token ? 'sim' : 'não';
    },
    async loadClient() {
      await this.clientService.query().then((data) => {
        this.clients = data;
        if (this.clients.length === 0) {
          this.showAlert = true;
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/features/user/UserForm.vue